var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7105 15.5427L18.3605 9.88267C18.4542 9.7897 18.5286 9.6791 18.5793 9.55724C18.6301 9.43538 18.6562 9.30468 18.6562 9.17267C18.6562 9.04066 18.6301 8.90995 18.5793 8.78809C18.5286 8.66623 18.4542 8.55563 18.3605 8.46267C18.1731 8.27642 17.9196 8.17187 17.6555 8.17187C17.3913 8.17187 17.1378 8.27642 16.9505 8.46267L11.9505 13.4127L7.00045 8.46267C6.81309 8.27642 6.55964 8.17187 6.29545 8.17187C6.03127 8.17187 5.77781 8.27642 5.59045 8.46267C5.49596 8.55528 5.42079 8.66573 5.3693 8.7876C5.3178 8.90948 5.291 9.04036 5.29045 9.17267C5.291 9.30497 5.3178 9.43586 5.3693 9.55773C5.42079 9.67961 5.49596 9.79005 5.59045 9.88267L11.2405 15.5427C11.3341 15.6442 11.4477 15.7252 11.5742 15.7806C11.7007 15.836 11.8373 15.8646 11.9755 15.8646C12.1136 15.8646 12.2502 15.836 12.3767 15.7806C12.5032 15.7252 12.6168 15.6442 12.7105 15.5427Z",
    fill: "#3D3D3D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down.e97e29b585d05ed704865b17c69e9f5c.svg";